<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
      </keep-alive>
    <div class="player page-container" :class="{'hide-player': $route.name !== 'Home'}">
      <div class="page-content pb">
        <div class="podcast-container">
            <h3 class="podcast-title">Hør episodene her</h3>
            <podcast-element
            v-for="podcast in $store.state.episodes"
            :key="podcast.id"
            :podcast="podcast"
          ></podcast-element>
          </div>
      </div>
    </div>
    <div class="footer-container" v-if="$route.query.view == undefined">
      <div class="grid podcasts" id="content-start"></div>
      <div v-if="this.articles.length > 0 && $store.state.provider == 'sa'" class="articles-container">
        <img class="articles-title" src="@/assets/alleartikler.png" />
        
        <div class="articles" >
          <article-element
            v-for="(article, index) in articles"
            v-bind:key="index"
            :article="article"
          ></article-element>
        </div>
      </div>
      <footer-element></footer-element>
    </div>
  </div>
</template>

<script>
import {store} from './store'

export default {
  name: "App",
  // SAVNET: https://mm.aftenbladet.no/backend/?type=collections&pub=sa&group=pages&story=28175ff6-02b8-4ca8-9c25-9e9a6e405ab1
  // TEST: https://mm.aftenbladet.no/backend/?type=collections&pub=sa&group=pages&story=08b9f491-f418-4ebe-85c0-058afa282270
  data() {
    return {
      articles: Object,
      provider: ""
    };
  },
  beforeMount() {
    this.getName();
  },
  mounted() {
    // let streamScript = document.createElement('script');
    // streamScript.setAttribute('src', 'https://cdn.stream.schibsted.media/embed/latest/js/embed.min.js')
    // streamScript.setAttribute('src', 'https://cdn.stream.schibsted.media/player/3.32.3/player.min.js')
    // document.head.appendChild(streamScript);

    // Check provider
    this.provider = document.getElementById('provider').getAttribute('data-provider')
    store.commit('SET_PROVIDER', this.provider)
},

  methods: {
    async getName() {
      await fetch(
        "https://mm.aftenbladet.no/backend/?type=collections&pub=sa&group=pages&size=30&story=28175ff6-02b8-4ca8-9c25-9e9a6e405ab1"
      )
        .then((res) => res.json())
        .then((res) => res.items)
        .then((res) => {
          let list = [];

          Object.entries(res).forEach(e => {
            if(e[1].type == "bundle" && e[1].items[0].customProperties.id != "Qm99ex") {
              list.push(e[1]);
            }
          })

        this.articles = list;
        });
    },
  },
};
</script>

<style lang="scss">
.page-container {
  max-width: 700px;
  margin: auto;
  padding: 0 0.4em;
  
  position: relative;
  z-index: 1;
  &.sub-pages {
    padding-top: 10px;
  }

  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#000000+13,000000+100&1+1,0+100 */
}

.page-header {
  margin-bottom: 2em;
}

.page-header-title {
  text-align: center;
  color: #000;
  padding-top: 0.4em;
}
.page-content {
  max-width: 700px;
  padding-top: 2rem;
  position: relative;
  z-index: 3;
  background-color: color("black-2");
  margin-bottom: -2px;
  padding-bottom: 1rem;
}
.page-title {
  text-align: center;
  margin: 0;
  padding: 2em 0 2em 0;
  font-size: 1.7em;
}

.hide-player {
  opacity: 0;
  height: 0;
  max-height: 0;
  position: absolute;
  top: -9999px;
  left: -9999px;
  overflow: hidden;
}
.podcast-container  {
  padding-bottom: 2rem;
}

#app {
  font-family: "Inter", sans-serif;
  min-width: $min-width;
  width: 100%;
  font-size: 16px;
  background-color: color("black");
  margin-bottom: 4rem;
  position: relative;
}

.mb {
  margin-bottom: 0.4em !important;
}
.footer-container {
  max-width: 700px;
  margin: auto;
  padding: 0 0.4em;
  position: relative;
  z-index: 1;
}

.wrapper {
  max-width: map-get($breakpoints, "mobile");
  margin: 0 auto;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.articles-container {
  margin: 3rem 0;
  display: flex;
  flex-direction: column;
  border: 1px solid color("white");
}

.articles {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.articles-title {
  height: 55px;
  @include desktop(){
    height: 63px;
  }
  margin-top: -1.8rem;
  align-self: center;
}

.podcast-title {
  text-align: center;
  margin: 0;
  padding: 0 0 0.7em 0;
  font-size: 1.7em;
  color: #fff;
}
</style>
